import { Action } from 'redux';

import { DeleteExtractRefresh } from '../../app/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';

export interface DeleteExtractRefreshAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function deleteExtractRefresh(tasks: IExtractTaskInfo[]): DeleteExtractRefreshAction {
  return {
    type: DeleteExtractRefresh,
    tasks
  };
}
